import { SVGProps } from 'react';

export function IconChainIntelligence({
  width = 72,
  height = 72,
  ...restProps
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...restProps}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
    >
      <path
        fill="currentColor"
        d="M26.68,25l27.8,0.08c0.61,0,1.13,0.35,1.37,0.91c0.24,0.56,0.13,1.18-0.29,1.62L39.57,44.49
		c-0.56,0.59-0.54,1.51,0.03,2.08l17.29,17.39c0.29,0.3,0.65,0.44,1.07,0.44c0.42,0,0.77-0.15,1.06-0.45l13.31-13.65
		c0.43-0.44,1.06-0.57,1.63-0.34c0.58,0.23,0.93,0.76,0.93,1.38l0.03,22.15c0,0.41-0.15,0.77-0.44,1.06
		C74.2,74.85,73.85,75,73.43,75l-46.87-0.02c-0.41,0-0.77-0.15-1.06-0.44c-0.29-0.29-0.44-0.65-0.44-1.06l0.11-46.98
		C25.18,25.67,25.85,25,26.68,25"
      />
      <path
        fill="currentColor"
        d="M55.46,33.91l11.94,0.03c0.65,0,1.18,0.54,1.18,1.19l-0.03,11.94c0,0.65-0.54,1.18-1.19,1.18l-11.94-0.03
		c-0.65,0-1.18-0.54-1.18-1.19l0.03-11.94C54.28,34.44,54.81,33.91,55.46,33.91"
      />
    </svg>
  );
}
